export default "__VITE_ASSET__YX0SlSnk__"